import React from "react";
import { Link as ScrollLink } from "react-scroll";
import "../../styles/VideoBanner.css";

export default function VideoBanner() {
    return (
        <div className="video-banner">
            <video autoPlay muted loop playsInline>
                <source src="/Medical_Antibiotic_Pills.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="video-overlay">
                <div className="overlay-content">

                    {/* Left Side - Heading */}
                    <div className="overlay-left">
                        <h1>
                            Investing in life, inventing the future,<br />
                            through pharmaceuticals
                        </h1>
                    </div>

                    {/* Right Side - Paragraph + Buttons */}
                    <div className="overlay-right-group">
                        <div className="overlay-center">
                            <p>
                                The team at Medamos Life Sciences are dedicated to helping partners find sustainable,<br />
                                innovative pharmaceutical solutions for an ever changing world
                            </p>
                        </div>
                        <div className="overlay-right">
                            <ScrollLink
                                className="overlay-btn"
                                to="about"
                                smooth={true}
                                duration={600}
                                offset={-80}
                            >
                                About Us
                            </ScrollLink>
                            <ScrollLink
                                className="overlay-btn"
                                to="contact"
                                smooth={true}
                                duration={600}
                                offset={-80}
                            >
                                Contact Us
                            </ScrollLink>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}
